import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { RequestStrategyEnum, RewardsApi, type GetBalanceResponse, type WithSignal } from '@shared/api';

const getBalanceEffect = createEffect(({ signal }: WithSignal = {}) => RewardsApi.getBalance(signal));
const clearEvent = createEvent();

const $dataStore = createStore<GetBalanceResponse | null>(null)
  .on(getBalanceEffect.done, (_, data) => data.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getBalanceEffect.pending, (_, data) => data)
  .on(getBalanceEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getBalanceEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getBalanceEffect, () => null)
  .on(getBalanceEffect.fail, () => 'Something went wrong while fetching Rewards Balance. Please try again.')
  .on(getBalanceEffect.done, () => null)
  .reset(clearEvent);

const getBalanceApi = ApiUtils.wrapperApi(getBalanceEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getBalanceApi.cancel());

export const $rewardsBalanceStore = {
  events: {
    getBalance: getBalanceApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
